import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Section from '../../components/common/Section';

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

const FeatureCard = styled.div`
  background-color: white;
  border-radius: ${props => props.theme.borderRadius.medium};
  padding: 2rem;
  box-shadow: ${props => props.theme.shadows.medium};
  transition: transform ${props => props.theme.transitions.medium};
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const FeatureTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.primary};
`;

const FeatureDescription = styled.p`
  color: ${props => props.theme.colors.lightText};
  line-height: 1.6;
`;

const Omnichannel = () => {
  const { t } = useTranslation();
  
  const features = [
    {
      title: t('solutions.omnichannel.features.integration'),
      description: '整合线上商城、实体店、社交媒体、移动应用等多种渠道，实现数据和流程的统一。'
    },
    {
      title: t('solutions.omnichannel.features.experience'),
      description: '确保客户在不同渠道之间切换时，能够获得一致且连贯的体验。'
    },
    {
      title: t('solutions.omnichannel.features.data'),
      description: '收集和分析来自各个渠道的客户数据，获取全面的客户洞察。'
    },
    {
      title: t('solutions.omnichannel.features.personalization'),
      description: '基于客户行为和偏好，在所有渠道提供个性化的内容和推荐。'
    },
    {
      title: t('solutions.omnichannel.features.inventory'),
      description: '实时跟踪和管理多渠道库存，确保库存信息的准确性和一致性。'
    }
  ];
  
  return (
    <>
      <Section 
        title={t('solutions.omnichannel.title')} 
        subtitle={t('solutions.omnichannel.subtitle')}
      >
        <p>{t('solutions.omnichannel.content')}</p>
        
        <FeatureGrid>
          {features.map((feature, index) => (
            <FeatureCard key={index}>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeatureGrid>
      </Section>
    </>
  );
};

export default Omnichannel;